import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05018f05")

_pushScopeId("data-v-05018f05")
const _hoisted_1 = { class: "card-body pt-0" }
const _hoisted_2 = { class: "table-responsive newDropdown" }
const _hoisted_3 = { class: "table table-row-dashed align-middle gs-0 gy-4" }
const _hoisted_4 = { class: "fw-bolder text-muted" }
const _hoisted_5 = { class: "arrows" }
const _hoisted_6 = {
  key: 0,
  class: "fas fa-sort-up"
}
const _hoisted_7 = {
  key: 1,
  class: "fas fa-sort-down"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "arrows" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-sort-up" }),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-sort-down" })
], -1)
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "el-empty" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "el-empty__image" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file" })
], -1)
const _hoisted_13 = { class: "el-empty__description" }
const _hoisted_14 = { class: "card-footer" }
const _hoisted_15 = { class: "text-muted fw-bold fs-6" }
const _hoisted_16 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CustomerDetailTableContentLoader = _resolveComponent("CustomerDetailTableContentLoader")!
  const _component_TableContentLoader = _resolveComponent("TableContentLoader")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_ctx.loading && _ctx.module)
    ? (_openBlock(), _createBlock(_component_CustomerDetailTableContentLoader, { key: 0 }))
    : (_ctx.loading && !_ctx.module)
      ? (_openBlock(), _createBlock(_component_TableContentLoader, { key: 1 }))
      : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("table", _hoisted_3, [
                _createVNode("thead", null, [
                  _createVNode("tr", _hoisted_4, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (column, prop) => {
                      return (_openBlock(), _createBlock("th", {
                        class: `${column.width ? 'min-w-100px' : 'min-w-140px'} text-${column.textAlignment ? column.textAlignment : 'start'}`,
                        scope: "col",
                        key: prop
                      }, [
                        (column.sorting && _ctx.state)
                          ? (_openBlock(), _createBlock("span", {
                              key: 0,
                              class: "pointers",
                              onClick: ($event: any) => (_ctx.changeType(_ctx.type), _ctx.$emit('sorting', 0, true, _ctx.$t(column.label), _ctx.type))
                            }, [
                              _createTextVNode(_toDisplayString(_ctx.$t(column.label)) + " ", 1),
                              _createVNode("span", _hoisted_5, [
                                (!_ctx.type && _ctx.state)
                                  ? (_openBlock(), _createBlock("i", _hoisted_6))
                                  : (_openBlock(), _createBlock("i", _hoisted_7))
                              ])
                            ], 8, ["onClick"]))
                          : (column.sorting && !_ctx.state)
                            ? (_openBlock(), _createBlock("span", {
                                key: 1,
                                class: "pointers",
                                onClick: ($event: any) => (_ctx.changeType(_ctx.type), _ctx.$emit('sorting', 0, true, _ctx.$t(column.label), _ctx.type))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t(column.label)) + " ", 1),
                                _hoisted_8
                              ], 8, ["onClick"]))
                            : (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t(column.label)), 1))
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createVNode("tbody", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (_, prop) => {
                        return (_openBlock(), _createBlock("td", {
                          key: prop,
                          class: `${_.width ? 'min-w-100px' : 'min-w-140px'} py-${_ctx.padding ? _ctx.padding : '0'} text-${_.textAlignment ? _.textAlignment : 'start'}`
                        }, [
                          _renderSlot(_ctx.$slots, 'cell-' + _.key, {
                            row: row,
                            prop: prop,
                            index: index
                          }, () => [
                            _createTextVNode(_toDisplayString(row[_.key]), 1)
                          ], true)
                        ], 2))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]),
              (_ctx.rows?.length == 0)
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode("div", _hoisted_13, [
                        _createVNode("p", null, _toDisplayString(_ctx.$t('message.NO_DATA_FOUND')), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, _toDisplayString(Object.keys(_ctx.pagination)?.length > 0 ? _ctx.pagination?.total : _ctx.rows?.length) + " " + _toDisplayString(_ctx.$t('message.RECORDS')), 1),
            (_ctx.pagination)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  _createVNode(_component_el_pagination, {
                    background: "",
                    style: {"float":"right"},
                    layout: "prev, pager, next",
                    "current-page": _ctx.pagination.current_page,
                    onCurrentChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('handleCurrentChange', $event))),
                    "page-size": _ctx.pagination.per_page,
                    total: _ctx.pagination?.total,
                    "pager-count": 3
                  }, null, 8, ["current-page", "page-size", "total"])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 64))
})